export default __webpack_public_path__ + "static/BayswaterCarousel_0004-ec0002043d0e4468b519c40626e1d775.jpg";